import { COUNTRY_STATES_DICTIONARY } from "@components/commerce/baseForms/statesConstants";
import { type GetDeliveryDatesResponse } from "@interfaces/heap-api";
import { dateSelectorEnabledDeliveryMethods } from "@lib/constants/dateSelectorDeliveryMethods";
import { ClientFetchService } from "@lib/helpers/clientFetchService";

export const isDateSelectorEnabled = (deliveryMethodId: string, country: string): boolean => {
    const deliveryMethods = dateSelectorEnabledDeliveryMethods[country];
    if (!deliveryMethods) {
        return false; // No delivery methods for the given country
    }
    return deliveryMethods.includes(deliveryMethodId);
};

/**
 * Fetches the delivery dates for a given cart, country, and region.
 */
export const getDeliveryDates = async (
    cartId: string,
    country: string,
    region: string,
    locale: string
): Promise<GetDeliveryDatesResponse | undefined> => {
    if (!dateSelectorEnabledDeliveryMethods.hasOwnProperty(country)) {
        return;
    }

    const queryParams = new URLSearchParams({
        ...(cartId && { cartId }),
        ...(region && { region: getRegionNameforValue(locale, region) }),
    });

    return await ClientFetchService.get(`/api/delivery-dates?${queryParams.toString()}`);
};

/**
 * Gets the region name for a given region value.
 */
const getRegionNameforValue = (locale: string, region: string): string | null => {
    const localeStatesDictionary = COUNTRY_STATES_DICTIONARY[locale];
    if (!localeStatesDictionary) {
        return null;
    }
    const regionName = localeStatesDictionary.find((state) => state.value === region);
    if (!regionName) {
        return null;
    }
    return regionName?.englishName ?? null;
};
